import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Banner.css";

const Banner = () => {
  const { t } = useTranslation();

  return (
    <section id="hero" className="hero d-flex align-items-center">
      <Container>
        <Row>
          <Col xl={4}>
            <h2 data-aos="fade-up">{t("banner.title")}</h2>
            <blockquote data-aos="fade-up" data-aos-delay="100" className="banner-quote">
              <p>{t("banner.subtitle")}</p>
            </blockquote>
            <div className="d-flex" data-aos="fade-up" data-aos-delay="200">
              <a href="#menus" className="btn-get-started">
                {t('banner.button')}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;